<template>
  <div class="tab-label-container">
    <el-badge v-if="count > 0" :value="count">
      {{ label }}
    </el-badge>
    <p v-else>{{ label }}</p>
  </div>
</template>

<script>
export default {
  props: {
    count: {
      type: Number,
      default: 0
    },
    label: {
      type: String,
      default: ""
    }
  }  
}
</script>

<style scoped>
.tab-label-container {
  position: relative;
  display: inline-block;
}

.new-tag-svg {
  position: absolute;
  top: -17px;
  right: -34px;
  width: 34px;
  height: 34px;
  z-index: 1;
}

.tab-label-container :deep(.el-badge__content.is-fixed) {
  right: -5px;
}
</style>